import React, { useState, useEffect } from 'react';
import { TextField, Box, List, CircularProgress, Grid, Typography, InputAdornment } from '@mui/material';
import axios from 'axios';
import { Link } from 'react-router-dom';
import debounce from 'lodash/debounce';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

const SalonSearchBar = ({ visible, setVisible, onSelectSalon }) => {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    // const [visible, setVisible] = useState(true)

    const searchUrl = (process.env.REACT_APP_SERVER) ? `https://salonserver-k8m8.onrender.com/salons` : `http://localhost:3001/salons`

    const debouncedSearch = debounce(async (searchQuery) => {
        if (!searchQuery) {
            setResults([]);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const response = await axios.get(`${searchUrl}/search?q=${encodeURIComponent(searchQuery)}`,
            );
            setResults(response.data);
            console.log('srch', response.data)
        } catch (err) {
            setError('Failed to fetch salons. Please try again.');
            setResults([]);
        } finally {
            setLoading(false);
        }
    }, 500);

    useEffect(() => {
        debouncedSearch(query);
        return () => debouncedSearch.cancel();
    }, [query]);

    const handleSelect = (salon) => {
        setQuery(salon.name);
        setResults([]);
        if (onSelectSalon) onSelectSalon(salon);
        setQuery('');
    };
    if (!visible) return null;
    return (
        <Box
            style={{ zIndex: 100 }}
            sx={{
                position: 'fixed',
                top: 64,
                left: 0,
                right: 0,
                zIndex: 1000,
                bgcolor: 'background.paper',
                boxShadow: 1,
                p: 1,
                borderRadius: 1,
            }}
        >
            <TextField
                fullWidth
                variant="outlined"
                placeholder="Search by pincode, service name, or salon name..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}

                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                    endAdornment:
                        (
                            <InputAdornment position="end">
                                {loading && <CircularProgress size={20} style={{ marginRight: 8 }} />}
                                <CloseIcon
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setVisible(false)}
                                    fontSize="small"
                                />
                            </InputAdornment>
                        )
                }}
                sx={{ mb: 1 }}

            />
            {error && (
                <Typography color="error" variant="body2" sx={{ p: 1 }}>
                    {error}
                </Typography>
            )}

            {results.length > 0 && (
                <List
                    sx={{
                        maxHeight: 400,
                        overflow: 'auto',
                        bgcolor: 'white',
                        border: 1,
                        borderColor: 'grey.300',
                        borderRadius: 1,
                    }}
                >
                    {results.map((salon) => (
                        <Link to={`/salon/${salon.id}`} // Navigate to salon page
                            key={salon.id}
                            style={{ textDecoration: 'none', color: 'inherit' }} // Remove default link styling
                            onClick={() => handleSelect(salon)}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    p: 1,
                                    '&:hover': { bgcolor: 'grey.100', borderRadius: 1 },
                                    cursor: 'pointer',
                                }}
                            >
                                <img
                                    src={salon.get_image_url || '/placeholder-image.jpg'} // Fallback image if URL is missing
                                    alt={salon.name}
                                    style={{ width: 250, height: 150, objectFit: 'cover', borderRadius: 4, marginRight: 10 }}
                                />
                                <Box>
                                    <Typography variant="body1" fontWeight="medium">
                                        {salon.name}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Address: {salon.address1 || 'N/A'}, {salon.address2 || 'N/A'}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Pincode: {salon.pincode || 'N/A'}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" fontWeight="medium">
                                        Services: {salon.services?.map(s => s.stype).join(', ') || 'N/A'}
                                    </Typography>
                                </Box>
                            </Box>
                        </Link>
                    ))}
                </List>
            )}
        </Box>
    );
};

export default SalonSearchBar;